// extracted by mini-css-extract-plugin
module.exports = {"input":"ContactRightPanel_input__GrFuG","container":"ContactRightPanel_container__ofXrF","box":"ContactRightPanel_box__2FpYk"};